import {EditEventFormValidationSchema} from '@/features/agenda/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const AgendaEditEventFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues: Partial<EditEventFormValidationSchema>
}) => {
    const form = useForm<EditEventFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(EditEventFormValidationSchema),
        defaultValues: defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
